import { api } from "../api";
import { Project } from "../../types/project.types";

export const projectService = api.injectEndpoints({
  endpoints: (build) => ({
    getAllProjects: build.query<Array<Project>, string>({
      query: () => ({
        url: "/project/all-projects"
      })
    }),
    getUserProjects: build.query<Array<Project>, string>({
      query: () => ({
        url: "/project/user-projects"
      })
    }),
  })
});

export const {
  useGetAllProjectsQuery,
  useGetUserProjectsQuery
} = projectService;